// Verkleint een gekozen foto in de browser (max. "maxSize" px, JPEG) vóór het
// uploaden - profielfoto's hoeven niet groter dan een paar honderd pixels te
// zijn en dit houdt het uploaden snel op mobiel.
export function resizeImageFile(file, maxSize = 512) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const objectUrl = URL.createObjectURL(file);
    img.onload = () => {
      const ratio = Math.min(1, maxSize / Math.max(img.width, img.height));
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(img.width * ratio);
      canvas.height = Math.round(img.height * ratio);
      canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
      URL.revokeObjectURL(objectUrl);
      canvas.toBlob(
        (blob) => (blob ? resolve(blob) : reject(new Error('Resize mislukt'))),
        'image/jpeg',
        0.85
      );
    };
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error('Afbeelding kon niet gelezen worden'));
    };
    img.src = objectUrl;
  });
}
